module.exports = __webpack_public_path__ + "img/header-ccc.1b03669.jpg";